import axios from "axios";
import { REACT_APP_NAVBAR_API } from "shared/constants";

export const fetchPaths = () => {
  return axios.get(String(REACT_APP_NAVBAR_API));
};
